
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".67","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M11.512 21.988a8.988 8.988 0 0013.075 4.75v0l3.112.888a.75.75 0 00.925-.925l-.887-3.113a8.988 8.988 0 00-7.25-13.575","stroke":"#fff"}}),_c('path',{attrs:{"d":"M4.261 17.588a9.012 9.012 0 113.15 3.15l-3.112.888a.75.75 0 01-.925-.925l.887-3.113z","stroke":"#56BFC7"}})])])
          )
        }
      }
    